let cachedFlags = null;
let cacheTimestamp = null;
const CACHE_DURATION = 60000; // 1 minute

/**
 * Load all feature flags from system config
 * Uses public endpoint to avoid authentication issues on public pages
 */
export async function loadFeatureFlags() {
  // Return cached flags if still valid
  if (cachedFlags && cacheTimestamp && Date.now() - cacheTimestamp < CACHE_DURATION) {
    return cachedFlags;
  }

  try {
    // Use public endpoint that doesn't require authentication
    const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
    const response = await fetch(`${API_URL}/api/public/feature-flags`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch feature flags: ${response.status}`);
    }
    
    const flags = await response.json();

    cachedFlags = flags;
    cacheTimestamp = Date.now();
    
    return flags;
  } catch (err) {
    console.error('Failed to load feature flags:', err);
    // Return defaults if loading fails
    return {
      allow_individual_registration: true,
      allow_company_registration: true,
      stripe_enabled: false,
      ai_chat_enabled: true,
      claims_enabled: true,
      qle_enabled: true,
      maintenance_mode_enabled: false,
      maintenance_mode_message: 'We are currently performing scheduled maintenance. We will be back shortly.',
      maintenance_mode_end_time: ''
    };
  }
}

/**
 * Check if a specific feature is enabled
 */
export async function isFeatureEnabled(featureName) {
  const flags = await loadFeatureFlags();
  // Values are already normalized to booleans in loadFeatureFlags
  // Return true only if explicitly enabled, false otherwise
  return flags[featureName] === true;
}

/**
 * Clear the cache (useful after updates)
 */
export function clearFeatureFlagsCache() {
  cachedFlags = null;
  cacheTimestamp = null;
}